import { render, staticRenderFns } from "./ColorsForm.vue?vue&type=template&id=497a46f2&"
import script from "./ColorsForm.vue?vue&type=script&lang=js&"
export * from "./ColorsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports